import { Eyebrow, Reveal } from "./Reveal";

const TEAM = [
    { name: "Sagar Ghune", role: "Admin Lead", initials: "SG" },
    { name: "Mrunal Kadam", role: "Admin Team", initials: "MK" },
    { name: "Meghana Mhasawade", role: "Finance Team", initials: "MM" },
    { name: "Vivek Dhaybar", role: "Finance Team", initials: "VD" },
    { name: "Mallika James", role: "Director — Finance and Admin", initials: "MJ" },
];

export function Team() {
    return (
        <section id="contact" data-testid="team-section" className="relative py-20 sm:py-28 bg-[var(--paper)] border-t border-[var(--line)] scroll-mt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl mb-12 sm:mb-16">
                    <Eyebrow>06 · Team</Eyebrow>
                    <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[var(--ink)]">
                        Built and Maintained by the Finance and Admin Team
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-slate-600">
                        Reach out for access, feedback, or help with the platform.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
                    {TEAM.map((m, i) => (
                        <Reveal key={m.name} delay={i * 0.08}>
                            <div
                                data-testid={`team-card-${i + 1}`}
                                className="h-full bg-[var(--bg)] border border-[var(--line)] rounded-xl p-6 flex flex-col items-center text-center shadow-[0_4px_20px_-4px_rgba(15,23,42,0.05)] hover:shadow-[0_12px_30px_-6px_rgba(212,169,60,0.14)] hover:-translate-y-[3px] transition-[transform,box-shadow] duration-200"
                            >
                                <div className="w-16 h-16 rounded-full bg-[var(--accent)] text-[#0A0908] font-display font-bold text-lg grid place-items-center tracking-wide">
                                    {m.initials}
                                </div>
                                <h3 className="mt-4 font-display font-bold text-base tracking-tight text-[var(--ink)]">{m.name}</h3>
                                <p className="mt-1 mono text-[11px] tracking-[0.14em] uppercase text-[var(--ink-3)]">{m.role}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
